import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AnimationsModule } from '../animations/animations.module';
import { ColorModule } from '../color/color.module';

import { DropdownComponent, DropdownToggleComponent, DropdownMenuComponent } from './dropdown.component';
export class DropdownModule {static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    imports: [CommonModule, AnimationsModule, ColorModule],
    exports: [DropdownComponent, DropdownToggleComponent, DropdownMenuComponent],
    declarations: [DropdownComponent, DropdownToggleComponent, DropdownMenuComponent]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function DropdownModule_tsickle_Closure_declarations() {
/** @type {?} */
DropdownModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
DropdownModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
